import { render } from "./who_to_follow.vue?vue&type=template&id=4f8c3288"
import script from "./who_to_follow.js?vue&type=script&lang=js"
export * from "./who_to_follow.js?vue&type=script&lang=js"

import exportComponent from "/woodpecker/src/akkoma.dev/AkkomaGang/akkoma-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__